import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import findPillClass from './utils/findPillClass';
import * as styles from './Pill.scss';

/**
 * Reusable Pill Component
 * @function Pill
 * @param {Object} props
 * @return {ReactElement}
 * @example ./Pill.md
 */
const Pill = props => {
  const {
    className,
    color = 'SILVER',
    disabled = false,
    hoverText,
    style,
    text = 'Active',
    textClassName,
  } = props;
  const pillClass = disabled
    ? styles.disabledPill
    : findPillClass(color);

  return (
    <div className={classNames(styles.pill, pillClass, className)} style={style}>
      <p className={classNames(styles.pillText, textClassName)} title={hoverText}>{text}</p>
    </div>
  );
};

Pill.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  hoverText: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  text: PropTypes.string,
  textClassName: PropTypes.string,
};

export default Pill;
